import Helper from './Helper';

class InteractiveNachhaltigkeit {
  constructor(config = {
    idMap: { de: [], fr: [] }, links: [], graphicQuery: ''
  }) {
    const {
      idMap,
      links,
      graphicQuery
    } = config;

    this.graphic = document.querySelector(graphicQuery);
    // current "index" of trigger for prev-next ranges from 1 - 5
    this.currentIndex = 1;
    this.lang = Helper.getLang().substring(0, 2);

    if (this.graphic) {
      this.animationLayer = this.graphic.querySelector(`#${this.lang}-trigger`);

      this.buildLinks(links);
      this.buildMap(this.lang == 'de' ? JSON.parse(JSON.stringify(idMap.de)) : JSON.parse(JSON.stringify(idMap.fr)));
      this.bindEvents();

      // set origin as group is not 1:1 ration
      const origin = Helper.isDesktop() ? this.animationLayer.getBoundingClientRect().height / 2 : this.animationLayer.getBoundingClientRect().width / 2;
      this.animationLayer.style.transformOrigin = `${origin}px ${origin}px`;
    }
  }

  bindEvents() {

    this.prev = this.graphic.querySelector('#icon-prev');
    this.next = this.graphic.querySelector('#icon-next');

    if (this.prev)
      this.prev.addEventListener('click', (e) => {
        this.goPrev();
      })

    if (this.next)
      this.next.addEventListener('click', (e) => {
        this.goNext();
      })

    this.map.forEach(mapItem => {
      if (mapItem.default) {
        this.activateMapItem(mapItem, false);
      }

      // Trigger event mapping
      mapItem.triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          this.clickHandler(mapItem, trigger);
        });
      });
    });
  }

  goPrev() {
    this.currentIndex--;
    if (this.currentIndex < 1) {
      this.currentIndex = 5;
    }

    this.map.forEach(item => {
      if (item.target.id.includes('target-' + this.currentIndex)) {
        this.activateMapItem(item, true, null, 'animate');
      }
    });

  }

  goNext() {
    this.currentIndex++;
    if (this.currentIndex > 5) {
      this.currentIndex = 1;
    }

    this.map.forEach(item => {
      if (item.target.id.includes('target-' + this.currentIndex)) {
        this.activateMapItem(item, true, null, 'animate-counterclockwise');
      }
    });
  }

  // Link elements / group on click
  buildLinks(links) {
    links.forEach(link => {
      const element = this.graphic.querySelector('#' + link.id);

      if (element) {
        element.addEventListener('click', (e) => {
          window.location.href = '../' + link.url;
        });
      }
    });
  }

  /** queries triggers, target and visible items from string */
  buildMap(map) {
    map.map(item => {
      item.triggers = this.graphic.querySelectorAll(item.triggers);
      item.target = this.graphic.querySelector(item.target);
      item.shows = this.graphic.querySelectorAll(item.shows);
    })

    this.map = map;
  }

  /** handle when clicking trigger */
  clickHandler(mapItem, trigger) {
    // get id from trigger for prev-next
    this.currentIndex = trigger.id.replace('de-trigger-', '').replace('fr-trigger-', '')[0];
    this.activateMapItem(mapItem, true, trigger);
  }

  activateMapItem(mapItem, useAnimation = true, trigger = null, overwriteAnimDirection = null) {

    // activate all required items
    if (!useAnimation) {
      this.graphic.querySelectorAll('.active').forEach(item => item.classList.remove('active'));
      mapItem.shows.forEach(item => item.classList.add('active'));
      if (mapItem.target) {
        mapItem.target.classList.add('active');
      }
    } else {
      // todo: play animation with js queues
      if (this.animTimeout) {
        clearTimeout(this.animTimeout);
      }

      this.graphic.querySelectorAll('.active').forEach(item => item.classList.remove('active'));
      mapItem.shows.forEach(item => item.classList.add('active'));
      mapItem.target.classList.add('active');

      let animationDir = overwriteAnimDirection ? overwriteAnimDirection : 'animate';

      if (trigger) {
        animationDir = trigger.id.replace('de-trigger-', '').replace('fr-trigger-', '')[2] >= 3 ? 'animate':'animate-counterclockwise';
      }

      if (this.animationLayer) {
        this.animationLayer.classList.add(animationDir);

        this.animTimeout = setTimeout(() => {
          this.animationLayer.classList.remove('animate');
          this.animationLayer.classList.remove('animate-counterclockwise');
        }, 1000);
      }
    }
  }

} export default InteractiveNachhaltigkeit;
